var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-center pa-4",attrs:{"dense":""}},[_c('v-img',{attrs:{"src":_vm.logo,"max-width":"350px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }